const TEMPLATE_IDS = {
	ARTICLE_LAYOUT: 'ArticleLayout',
}

module.exports = {
	TEMPLATE_IDS,
}
